/**
 * 异常请求报错处理 + 返回值截取处理
 *
 * @file response.js
 * @author yangwei(yangwei14@baidu.com)
 */
import _ from 'lodash';
import {notification} from '@baiducloud/bce-ui';

import CodeMap from '../code-map';
// IIFE
import {showLogin} from '../../common/user';
import {isConsole} from '../../console/common/utils';

export default () => (res, next) => {

    const {message} = res.data;
    const options = res.config;
    let status = _.get(res, 'data.status') || _.get(res, 'data.code');
    status = parseInt(status, 10);

    // 重定向
    if (status === CodeMap.NOT_LOGIN.code) {
        if (isConsole()) {
            let timer = setTimeout(() => {
                showLogin();
                clearTimeout(timer);
            });
        }
        // 管理页面
        isConsole()
        && !res.config.url.includes('/user/detail')
        && notification.error(CodeMap.NOT_LOGIN.message);
        return;
    }
    //  静默模式直接返回不处理
    if (options['x-silent'] || options['X-Silence']) {
        next();
        return;
    }

    //  其他不成功的情况
    if (status && status !== CodeMap.SUCCESS.code) {
        const codeObj = _.find(CodeMap, tag => tag.code === status) || {};

        isConsole()
        && notification.error(codeObj.message || message || '系统提示：请求失败(未知错误)', {duration: 5});
        res.status = 500;
    }
    next();
};
